export enum ECancelBy {
  CANCELLED_BY_OWNER = 'CANCELLED_BY_OWNER',
  CANCELLED_BY_TRAVELER = 'CANCELLED_BY_TRAVELER',
}
